<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_107_8939)">
      <path
        d="M2.5 10C2.5 13.1427 2.5 16.3807 3.59835 17.357C4.6967 18.3333 6.46447 18.3333 10 18.3333C13.5355 18.3333 15.3033 18.3333 16.4017 17.357C17.5 16.3807 17.5 13.1427 17.5 10"
        opacity="0.5"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M12.2163 11.8349L17.3809 10.2855C17.7233 10.1828 17.8946 10.1314 18.0213 10.0296C18.132 9.94067 18.2182 9.82483 18.2715 9.69325C18.3327 9.54258 18.3327 9.36383 18.3327 9.00642C18.3327 7.60023 18.3327 6.89715 18.0579 6.36057C17.8188 5.89368 17.439 5.51382 16.9721 5.27476C16.4355 5 15.7324 5 14.3263 5H5.67239C4.26624 5 3.56317 5 3.02658 5.27476C2.5597 5.51382 2.17984 5.89368 1.94077 6.36057C1.66602 6.89715 1.66602 7.60023 1.66602 9.00642C1.66602 9.36383 1.66602 9.54258 1.72715 9.69325C1.78054 9.82483 1.86667 9.94067 1.97737 10.0296C2.10413 10.1314 2.27533 10.1828 2.61773 10.2855L7.78241 11.8349"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M11.666 10.4167H8.33268C8.10257 10.4167 7.91602 10.6033 7.91602 10.8334V12.6347C7.91602 12.805 8.01975 12.9582 8.17793 13.0215L8.76135 13.2549C9.5561 13.5727 10.4426 13.5727 11.2373 13.2549L11.8208 13.0215C11.9789 12.9582 12.0827 12.805 12.0827 12.6347V10.8334C12.0827 10.6033 11.8961 10.4167 11.666 10.4167Z"
        stroke="white"
        stroke-linecap="round"
        stroke-width="1.5"
      />
      <path
        d="M7.64258 3.33341C7.98577 2.36242 8.91183 1.66675 10.0003 1.66675C11.0888 1.66675 12.0149 2.36242 12.3581 3.33341"
        opacity="0.5"
        stroke="white"
        stroke-linecap="round"
        stroke-width="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_107_8939">
        <rect
          fill="white"
          height="20"
          width="20"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'NlpWhoIsForIcon1',
}
</script>